import {AfterViewInit, Component, ElementRef, ViewChild,} from "@angular/core";
import {Store} from "@ngrx/store";
import {ThreeService} from "./rendering/threejs/three.service";
import {ThreeInputService} from "./inputs/input-middlewares/three-input.middleware";
// import { PostComponentService } from "../map/types/post/post-component";
import {InputService} from "./inputs/services/input.service";
import {MapInputService} from "./inputs/input-middlewares/map-input.middleware";
import {SurfaceService} from "./surface/surface.service";
import {DebrisService} from "./ambients/debris-service";
import {EventSenderService} from "./tests/event-sender.service";
import {HeaderBarComponent} from "../interface-components/header-bar/header-bar.component";
import {cameraActions} from "../state/camera/camera.actions";
import {BontrollerComponent} from "../interface-components/bontroller/bontroller.component";
import {ActivatedRoute, Router, RouterOutlet} from "@angular/router";
import {of, switchMap} from "rxjs";
import {authActions} from "../state/auth/auth.actions";

import * as interfaceSelectors from "../state/interface/interface.selector"
import {NgClass, NgIf} from "@angular/common";
import {ChatsService} from "../services/chats.service";
import {ContextMenuComponent} from "../interface-components/context-menu/context-menu.component";
import {PushNotificationService} from "../services/notifications/push-notification-service.service";
import {PwaInstallService} from "../services/notifications/pwa-install.service";
import {EventsWebsocketService} from "../services/entities/events-websocket.service";
import {ReactionsService} from "../services/reactions.service";
import {worldActions} from "../state/world/world.actions";
import {DoWhenReadyService, Readyables} from "../services/do-when-ready.service";
import {networkActions} from "../state/network/network.actions";
import {settings} from "../settings/settings";
import {CanvasService} from "./surface/canvas/canvas.service";
import {BinstService} from "./binst.service";
import {selectWorldDebuggers} from "../state/world/world.selector";
import {ToolbarLocationComponent} from "../interface-components/toolbar-location/toolbar-location.component";
import {ToolbarActionsComponent} from "../interface-components/toolbar-actions/toolbar-actions.component";
import {
    ToolbarProfileSearchComponent
} from "../interface-components/toolbar-profile-search/toolbar-profile-search.component";

export enum PaneType {
  search = 'search',
  profile = 'profile',
  none = 'none'
}

@Component({
  selector: "binsta-binst",
  standalone: true,
    imports: [HeaderBarComponent, BontrollerComponent, RouterOutlet, NgClass, ContextMenuComponent, NgIf, ToolbarLocationComponent, ToolbarActionsComponent, ToolbarProfileSearchComponent],
  templateUrl: "./binst.component.html",
  styleUrl: "./binst.component.scss",
})
export class BinstComponent implements AfterViewInit {
  constructor(
    private canvasService: CanvasService,
    private surfaceService: SurfaceService,
    private store: Store,
    private router: Router,
    private route: ActivatedRoute,
    private binstService: BinstService,
  ) {
    this.store.select(interfaceSelectors.selectContextMenuIsOpen).subscribe((isOpen) => {
      this.contextMenuOpen = isOpen;
    })
    this.store.select(selectWorldDebuggers).subscribe((debuggers) => {
      this.debuggers = debuggers
    })
    this.showDebugWindow = settings.debugWindow
  }

  debuggers = {}
  showDebugWindow = false

  chatsBarHovered = true;
  chatBarOpen = false;
  contextMenuOpen = false;

  setChatHovered(hovered: boolean) {
    this.chatsBarHovered = hovered || !this.chatBarOpen;
    this.store.dispatch(
        cameraActions.triggeredCanvasResizeAnimation({ durationMs: 1000 }),
    );
  }

  readonly childActive$ = this.router.events.pipe(
      switchMap(() => of(this.route.children.length > 0))
  );

  @ViewChild("canvas")
  private canvasRef: ElementRef;


  debug = false;
  leftPaneActive: boolean = false;
  rightPaneActive: boolean = false;
  panePopUpTopRightActive: boolean = false;
  panePopUpBottomRightActive: boolean = false;

  private get canvas(): HTMLCanvasElement {
    return this.canvasRef.nativeElement;
  }

  setupSubscriptions() {
    this.router.events.subscribe((event) => {
      this.checkIfPanesActive()
      // if (event.type === EventType.NavigationEnd) {
        this.store.dispatch(
            cameraActions.triggeredCanvasResizeAnimation({ durationMs: 500 }),
        );
      // }
    })
    this.checkIfPanesActive()
  }

  toggleProfile() {
    if (!this.panePopUpTopRightActive) {
      this.router.navigate([{outlets: {'pop-up-top-right': "profile-dropdown"}}])
    } else {
      this.router.navigate([{outlets: {'pop-up-top-right': null}}])
    }
  }

  checkIfPanesActive() {
    const leftPaneRoute = this.route.children.find(
        child => child.outlet === 'left-pane'
    );
    const rightPaneRoute = this.route.children.find(
        child => child.outlet === 'right-pane'
    );
    const popUpTopRight = this.route.children.find(
        child => child.outlet === 'pop-up-top-right'
    );
    const popUpBottomRight = this.route.children.find(
        child => child.outlet === 'pop-up-bottom-right'
    );
    if (!this.leftPaneActive && !!leftPaneRoute) {
      this.chatsBarHovered = true
    }
    this.chatBarOpen = leftPaneRoute?.snapshot?.routeConfig?.path === 'chat-bar';
    if (!this.chatBarOpen) this.setChatHovered(true)
    this.leftPaneActive = !!leftPaneRoute
    this.rightPaneActive = !!rightPaneRoute
    this.panePopUpTopRightActive = !!popUpTopRight
    this.panePopUpBottomRightActive = !!popUpBottomRight
  }

  async ngAfterViewInit(): Promise<void> {
    this.binstService.startBinstView()
    this.setupSubscriptions();
    this.canvasService.setDocument(document);
    await this.binstService.setupCanvas(this.canvas);
    await this.binstService.setupSurfaces()
    await this.binstService.startThree()
    await this.binstService.startDebris()
    await this.binstService.setupInputs()
    await this.surfaceService.updateCamera()
  }

  protected readonly Object = Object;
}
